// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"617":"83829fff","663":"388399d8"}[chunkId] + ".chunk.js";
};